import React from "react";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { WhyPro } from "../components/WhyPro";
import { WhyElite } from "../components/WhyElite";
import { ComparisonTable } from "../components/ComparisonTable";
import { Manifesto } from "../components/Manifesto";
import { FinalCTA } from "../components/FinalCTA";
import { Footer } from "../components/Footer";
import { StickyMobileCTA } from "../components/StickyMobileCTA";
import { TechBackground } from "../components/TechBackground";

export default function Landing() {
  return (
    <div className="relative bg-[#080A0C]" data-testid="landing-page">
      {/* Hero has its own layered background */}
      <div className="relative">
        <TechBackground variant="hero" />
        <Hero />
      </div>

      <Marquee />
      <WhyPro />
      <ComparisonTable />
      <WhyElite />
      <Manifesto />
      <FinalCTA />
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
